<template>
    <div id="foot-bar">
        <div class="foot-bar-item" @click="gotoView('/category')">
            <div
                class="foot-bar-icon category-icon"
                :class="{ active: routerPath == '/category' }"
            ></div>
            <div
                class="foot-bar-text"
                :class="{ active: routerPath == '/category' }"
            >
                <span>分类</span>
            </div>
        </div>
        <div class="foot-bar-item" @click="gotoView('/user/order/list')">
            <div
                class="foot-bar-icon order-icon"
                :class="{ active: routerPath == '/user/order/list' }"
            ></div>
            <div
                class="foot-bar-text"
                :class="{ active: routerPath == '/user/order/list' }"
            >
                <span>订单</span>
            </div>
        </div>
        <div class="foot-bar-item" @click="gotoView('/')">
            <div
                class="foot-bar-icon home-icon"
                :class="{ active: routerPath == '/' }"
            ></div>
            <div class="foot-bar-text" :class="{ active: routerPath == '/' }">
                <span>首页</span>
            </div>
        </div>
        <div class="foot-bar-item" @click="gotoView('/cart')">
            <div
                class="foot-bar-icon cart-icon"
                :class="{ active: routerPath == '/cart' }"
            ></div>
            <div
                class="foot-bar-text"
                :class="{ active: routerPath == '/cart' }"
            >
                <span>购物车</span>
            </div>
        </div>
        <div class="foot-bar-item" @click="gotoView('/user/self')">
            <div
                class="foot-bar-icon user-icon"
                :class="{ active: routerPath == '/user/self' }"
            ></div>
            <div
                class="foot-bar-text"
                :class="{ active: routerPath == '/user/self' }"
            >
                <span>我的</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "FootBar",
    computed: {
        //当前路由
        routerPath() {
            return this.$route.path;
        },
    },
    methods: {
        /**
         * @description 跳转页面
         */
        gotoView(path) {
            if (!path) return;
            this.$router.push({
                path: path,
            });
        },
    },
};
</script>
<style lang="less" scoped>
#foot-bar {
    position: fixed;
    z-index: 99;
    left: 50%;
    bottom: 0;
    width: 750px;
    height: 100px;
    margin-left: -375px;
    background-color: #fff;
    border-top: 1px solid #f2f2f2;
    > .foot-bar-item {
        float: left;
        width: 20%;
        height: 100px;
        .foot-bar-icon {
            height: 60px;
            background-repeat: no-repeat;
            background-position: center bottom;
            background-size: 56px;
        }
        .category-icon {
            background-image: url("../public/images/footbar/category-icon-default.png");
            &.active {
                background-image: url("../public/images/footbar/category-icon-active.png");
            }
        }
        .order-icon {
            background-image: url("../public/images/footbar/order-icon-default.png");
            &.active {
                background-image: url("../public/images/footbar/order-icon-active.png");
            }
        }
        .home-icon {
            background-image: url("../public/images/footbar/home-icon-default.png");
            &.active {
                background-image: url("../public/images/footbar/home-icon-active.png");
            }
        }
        .cart-icon {
            background-image: url("../public/images/footbar/cart-icon-default.png");
            &.active {
                background-image: url("../public/images/footbar/cart-icon-active.png");
            }
        }
        .user-icon {
            background-image: url("../public/images/footbar/user-icon-default.png");
            &.active {
                background-image: url("../public/images/footbar/user-icon-active.png");
            }
        }
        .foot-bar-text {
            height: 40px;
            text-align: center;
            font-size: 20px;
            line-height: 40px;
            color: #999;
            &.active {
                color: @theme-color;
            }
        }
    }
}
</style>
